/**
 * Décisions des gardes de route (`route-guards.tsx`), sans React : testées par
 * `route-guard-states.test.mjs`.
 */

export type FeatureGuardState = 'loading' | 'redirect' | 'render'

/**
 * Garde de flag : tant que Flipt charge, le flag rend son repli fermé — décider avant la réponse
 * expulserait la page (redirection `replace`, sans retour). Flag OFF : la page n'existe pas.
 */
export const featureGuardState = ({
  flagsReady,
  featureEnabled,
}: {
  flagsReady: boolean
  featureEnabled: boolean
}): FeatureGuardState => {
  if (!flagsReady) return 'loading'
  return featureEnabled ? 'render' : 'redirect'
}

export type RightsGuardState = 'loading' | 'denied' | 'render'

/** Garde de droits : attendre la session avant de juger, sinon un admin autorisé verrait un refus. */
export const rightsGuardState = ({
  authLoading,
  authorized,
}: {
  authLoading: boolean
  authorized: boolean
}): RightsGuardState => {
  if (authLoading) return 'loading'
  return authorized ? 'render' : 'denied'
}
